// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMarkCircle20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMarkCircle20Filled: FC<QuestionMarkCircle20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M10 15a.964.964 0 0 0 .708-.292A.964.964 0 0 0 11 14a.964.964 0 0 0-.292-.708A.964.964 0 0 0 10 13a.964.964 0 0 0-.708.292A.964.964 0 0 0 9 14c0 .278.097.514.292.708.194.195.43.292.708.292Zm-.75-3.188h1.52c0-.513.046-.878.136-1.093.09-.215.31-.49.656-.823.487-.472.823-.875 1.01-1.209.188-.333.282-.7.282-1.104 0-.764-.26-1.385-.781-1.864-.52-.48-1.184-.719-1.99-.719-.708 0-1.323.188-1.843.563-.521.375-.886.881-1.094 1.52l1.354.563c.125-.39.323-.691.594-.906.27-.216.587-.323.948-.323.389 0 .708.11.958.333.25.222.375.514.375.875 0 .32-.108.604-.323.854-.215.25-.455.493-.719.73-.486.444-.788.808-.906 1.093-.118.285-.177.788-.177 1.51ZM10 18a7.796 7.796 0 0 1-3.104-.625 8.064 8.064 0 0 1-2.552-1.719 8.063 8.063 0 0 1-1.719-2.552A7.797 7.797 0 0 1 2 10c0-1.111.208-2.15.625-3.115a8.064 8.064 0 0 1 4.27-4.26A7.797 7.797 0 0 1 10 2c1.111 0 2.15.208 3.115.625a8.095 8.095 0 0 1 4.26 4.26C17.792 7.851 18 8.89 18 10a7.797 7.797 0 0 1-.625 3.104 8.063 8.063 0 0 1-4.26 4.271A7.774 7.774 0 0 1 10 18Z" />
        </svg>
    );
};

export default QuestionMarkCircle20Filled;
